import React from 'react';
import { 
  Box, 
  Container, 
  Typography, 
  Stack, 
  Link as MuiLink,
  IconButton
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';

function Footer() {
  return (
    <Box 
      component="footer" 
      sx={{ 
        bgcolor: 'primary.dark',
        color: 'white',
        py: 6,
        mt: 'auto'
      }}
    >
      <Container maxWidth="lg">
        <Stack 
          direction={{ xs: 'column', md: 'row' }} 
          spacing={4} 
          justifyContent="space-between"
          sx={{ mb: 4 }}
        >
          <Box>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Richard Otieno for Teachers Union
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.8, maxWidth: 300 }}>
              Fighting for better working conditions, fair compensation, and quality education for all.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Quick Links
            </Typography>
            <Stack spacing={1}>
              <MuiLink 
                component={RouterLink} 
                to="/" 
                color="inherit" 
                sx={{ 
                  textDecoration: 'none',
                  '&:hover': { textDecoration: 'underline' }
                }}
              >
                Home
              </MuiLink>
              <MuiLink 
                component={RouterLink} 
                to="/about" 
                color="inherit" 
                sx={{ 
                  textDecoration: 'none',
                  '&:hover': { textDecoration: 'underline' }
                }}
              >
                About
              </MuiLink>
              <MuiLink 
                component={RouterLink} 
                to="/contact" 
                color="inherit" 
                sx={{ 
                  textDecoration: 'none',
                  '&:hover': { textDecoration: 'underline' }
                }}
              >
                Contact
              </MuiLink>
            </Stack>
          </Box>

          <Box>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Contact
            </Typography>
            <Stack spacing={1}>
              <Typography variant="body2" sx={{ opacity: 0.8 }}>
                Ndori High School
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.8 }}>
                richard@richardotieno.org
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.8 }}>
                +254 726 766 656
              </Typography>
            </Stack>
          </Box>

          <Box>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Legal
            </Typography>
            <Stack spacing={1}>
              <MuiLink 
                component={RouterLink} 
                to="/privacy-policy" 
                color="inherit" 
                sx={{ 
                  textDecoration: 'none',
                  '&:hover': { textDecoration: 'underline' }
                }}
              >
                Privacy Policy
              </MuiLink>
              <MuiLink 
                component={RouterLink} 
                to="/terms-of-service" 
                color="inherit" 
                sx={{ 
                  textDecoration: 'none',
                  '&:hover': { textDecoration: 'underline' }
                }}
              >
                Terms of Service
              </MuiLink>
            </Stack>
          </Box>

          <Box>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Connect With Us
            </Typography>
            <Stack direction="row" spacing={1}>
              <IconButton 
                color="inherit" 
                aria-label="Facebook"
                component="a"
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FacebookIcon />
              </IconButton>
              <IconButton 
                color="inherit" 
                aria-label="Twitter"
                component="a"
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <TwitterIcon />
              </IconButton>
              <IconButton 
                color="inherit" 
                aria-label="Instagram"
                component="a"
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <InstagramIcon />
              </IconButton>
            </Stack>
          </Box>
        </Stack>

        <Stack 
          direction={{ xs: 'column', sm: 'row' }} 
          justifyContent="space-between" 
          alignItems={{ xs: 'center', sm: 'flex-start' }}
          spacing={2}
        >
          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            © {new Date().getFullYear()} Richard Otieno for Teachers Union. All rights reserved.
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            Paid for by Friends of Richard Otieno
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
}

export default Footer; 